import { LogoSlider as Slider } from "../../../sanity/lib/types/logoSlider";
import { ImageElement } from "../Image";

export default function ({ slider }: { slider: Slider }) {
    return (
        <section title={slider.title} className="container py-10 logo-slider">
            <div className="mx-2.5 md:mx-5">
                <h2 className="text-body-m">{slider.title}</h2>
                {slider.logos && (
                    <div
                        style={
                            {
                                "--slider-width": slider.logos.length * 2 * 230 + "px",
                                "--slider-width-mobile": slider.logos.length * 2 * 206 + "px",
                                "--animation-duration": slider.logos.length * 2.5 + "s",
                            } as React.CSSProperties
                        }
                        className="logo-slider"
                    >
                        <div
                            className={`logo-track w-[var(--slider-width-mobile)] md:w-[var(--slider-width)] duration-[var(--animation-duration)]`}
                        >
                            {slider.logos.map(
                                (logo, index) =>
                                    logo.image && (
                                        <div key={index} className="w-[206px] md:w-[230px]">
                                            <ImageElement
                                                className="w-full"
                                                width={460}
                                                src={logo.image}
                                            />
                                        </div>
                                    ),
                            )}
                            {slider.logos.map(
                                (logo, index) =>
                                    logo.image && (
                                        <div key={index} className="w-[206px] md:w-[230px]">
                                            <ImageElement
                                                className="w-full"
                                                width={460}
                                                src={logo.image}
                                            />
                                        </div>
                                    ),
                            )}
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}
